import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/coaching-journey/coaching-journey.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/connect-with-coach/connect-with-coach.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyCoaching"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/discover/why-coaching.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LearnMore"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/learn-more/learn-more.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/our-coaches/our-coaches.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/our-practices/our-practices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/vercel/path0/web/src/app/(site)/discover/coaching/v2/components/wrapper/wrapper.tsx");
